import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Custom CacheProvider"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "custom-cacheprovider"
    }}>{`Custom CacheProvider`}</h1>
    <h2 {...{
      "id": "style-container"
    }}>{`Style container`}</h2>
    <p>{`You may come across a situation where you want to inject the generated styles into a
different element than the current document head (an iframe perhaps).`}</p>
    <p>{`By using the CacheProvider from `}<inlineCode parentName="p">{`@emotion/react`}</inlineCode>{` and `}<inlineCode parentName="p">{`createCache`}</inlineCode>{` from `}<inlineCode parentName="p">{`@emotion/cache`}</inlineCode>{` you can
specify the target container element.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { ThemeProvider } from 'theme-ui'
import { CacheProvider } from '@emotion/react'
import createCache from '@emotion/cache'

/**
 * @see https://emotion.sh/docs/@emotion/cache
 */
const cache = createCache({
  container: document.getElementById('my-cool-iframe'),
})

const theme = {
  colors: {
    text: 'tomato',
  },
}

export default ({ children }) => {
  return (
    <CacheProvider value={cache}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </CacheProvider>
  )
}
`}</code></pre>
    <h3 {...{
      "id": "with-react-frame-component"
    }}>{`With react-frame-component`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { ThemeProvider } from 'theme-ui'
import { CacheProvider } from '@emotion/react'
import createCache from '@emotion/cache'
import Iframe, { FrameContextConsumer } from 'react-frame-component'

const theme = {
  colors: {
    text: 'tomato',
  },
}

export default ({ children }) => {
  return (
    <Iframe initialContent="IFRAME_CONTENT">
      <FrameContextConsumer>
        {(frameContext) => {
          const cache = createCache({
            container: frameContext.document.head,
          })
          return (
            <CacheProvider value={cache}>
              <ThemeProvider theme={theme}>{children}</ThemeProvider>
            </CacheProvider>
          )
        }}
      </FrameContextConsumer>
    </Iframe>
  )
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      